import { sendBugsnagError } from "@utils/Bugsnag";
import { errorResponseMessage } from "./errorResponseMessage";
import { isSchemaError } from "./isSchemaError";

export const sendSupportMsg = body => async (dispatch, getState, api) => {
  try {
    await api.post("v3/messages/support", body);
    return "success";
  } catch (error) {
    sendBugsnagError(error, "actions/sendSupportMsg");
    let message = errorResponseMessage(error);
    if (isSchemaError(message)) {
      message = "Something went wrong, please refresh the page.";
    }

    return { error: message };
  }
};
